// extracted by mini-css-extract-plugin
export default {"right_nav":"right-nav_right_nav__QOAaB","nav_link":"right-nav_nav_link__WSAbS"};